import 'svelte/internal/disclose-version';

Booking[$.FILENAME] = 'src/web/concepts/booking.svelte';

import * as $ from 'svelte/internal/client';
import SlotPicker from "./slot_picker.svelte";

var root = $.add_locations($.from_html(`<p class="opacity-60"> </p>`), Booking[$.FILENAME], [[14, 17]]);

var root_1 = $.add_locations(
	$.from_html(
		`
  <div class="flex flex-col gap-3 text-center">
    <p class="font-display text-4xl md:text-6xl font-semibold tracking-tight">Booked.</p>
    <p class="text-lg md:text-xl">A video call link is on its way to <strong> </strong> for <strong> </strong>.</p>
    <!>
  </div>
`,
		1
	),
	Booking[$.FILENAME],
	[[11, 2, [[12, 4], [13, 4, [[13, 69], [13, 98]]]]]]
);

var root_2 = $.add_locations(
	$.from_html(
		`
  <form class="flex flex-col gap-5 w-full max-w-2xl">
    <!>
    <div class="grid md:grid-cols-2 gap-4">
      <input class="field" placeholder="Your name" required=""/>
      <input class="field" type="email" placeholder="Work email" required=""/>
    </div>
    <button class="btn self-start"> </button>
  </form>
`,
		1
	),
	Booking[$.FILENAME],
	[[17, 2, [[19, 4, [[20, 6], [21, 6]]], [23, 4]]]]
);

var root_3 = $.add_locations(
	$.from_html(
		`

<!>`,
		1
	),
	Booking[$.FILENAME],
	[]
);

function Booking($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Booking);

	var $$ownership_validator = $.create_ownership_validator($$props);

	let slot = $.prop($$props, 'slot', 15, null),
		cta = $.prop($$props, 'cta', 3, "Book the call"),
		summary = $.prop($$props, 'summary', 3, "");

	let name = $.tag($.state(""), 'name');
	let email = $.tag($.state(""), 'email');
	let done = $.tag($.state(false), 'done');
	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_3();
	var node = $.sibling($.first_child(fragment));

	{
		var consequent_1 = ($$anchor) => {
			var fragment_1 = root_1();
			var div = $.sibling($.first_child(fragment_1));
			var p = $.sibling($.child(div), 3);
			var strong = $.sibling($.child(p));
			var text = $.only_child(strong, true);
			var strong_1 = $.sibling(strong, 2);
			var text_1 = $.only_child(strong_1, true);

			$.next();
			$.reset(p);

			var node_1 = $.sibling(p, 2);

			{
				var consequent = ($$anchor) => {
					var p_1 = root();
					var text_2 = $.only_child(p_1, true);

					$.template_effect(() => $.set_text(text_2, summary()));
					$.append($$anchor, p_1);
				};

				$.add_svelte_meta(
					() => $.if(node_1, ($$render) => {
						if (summary()) $$render(consequent);
					}),
					'if',
					Booking,
					14,
					4
				);
			}

			$.next();
			$.reset(div);
			$.next();

			$.template_effect(() => {
				$.set_text(text, $.get(email));
				$.set_text(text_1, slot());
			});

			$.append($$anchor, fragment_1);
		};

		var alternate = ($$anchor) => {
			var fragment_2 = root_2();
			var form = $.sibling($.first_child(fragment_2));
			var node_2 = $.sibling($.child(form));

			{
				$$ownership_validator.binding('slot', SlotPicker, slot);

				$.add_svelte_meta(
					() => SlotPicker(node_2, {
						get value() {
							return slot();
						},

						set value($$value) {
							slot($$value);
						}
					}),
					'component',
					Booking,
					18,
					4,
					{ componentTag: 'SlotPicker' }
				);
			}

			var div_1 = $.sibling(node_2, 2);
			var input = $.sibling($.child(div_1));

			$.remove_input_defaults(input);

			var input_1 = $.sibling(input, 2);

			$.remove_input_defaults(input_1);
			$.next();
			$.reset(div_1);

			var button = $.sibling(div_1, 2);
			var text_3 = $.only_child(button, true);

			$.next();
			$.reset(form);
			$.next();

			$.template_effect(() => {
				button.disabled = !slot();
				$.set_text(text_3, slot() ? `${cta()}: ${slot()}` : "Pick a time");
			});

			$.event('submit', form, function submit(e) {
				e.preventDefault();
				$.set(done, true);
			});

			$.bind_value(
				input,
				function get() {
					return $.get(name);
				},
				function set($$value) {
					$.set(name, $$value);
				}
			);

			$.bind_value(
				input_1,
				function get() {
					return $.get(email);
				},
				function set($$value) {
					$.set(email, $$value);
				}
			);

			$.append($$anchor, fragment_2);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($.get(done)) $$render(consequent_1); else $$render(alternate, -1);
			}),
			'if',
			Booking,
			10,
			0
		);
	}

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	Booking = $.hmr(Booking);

	import.meta.hot.accept((module) => {
		Booking[$.HMR].update(module.default);
	});
}

export default Booking;